import { Thermo } from '@ts/components/Thermo';
import { init as initSchedule } from "./schedule";
import { init as initShare } from "./share";

export const init = () => {
    setThermo();
    initSchedule();
    initShare();
}

const setThermo = () => {
    const stepThermometer = Thermo.create(".thermo");
}